
//A* ...

export function astar(graph) {
    const visitedNodesIdInOrder = []
    const startNodeId = graph.startNode
    var heuristics = [], priorities = []
    heuristics = heuristic(graph)

    graph.list[startNodeId].distanceToStartNode = 0

    for (let i = 0; i < graph.vertices; i++) 
        priorities[i] = Infinity;
    
    priorities[startNodeId] = heuristics[startNodeId];
    
    while (true) {
        let lowestPriorityIndex = findLowestPriority(graph, priorities)
        
        if (lowestPriorityIndex === graph.finishNode)
            return visitedNodesIdInOrder;

        visitedNodesIdInOrder.push(lowestPriorityIndex)
        updatePriorityNeighbors(graph, lowestPriorityIndex, priorities, heuristics)
        graph.list[lowestPriorityIndex].isVisited = true
    }
}

// Heuristica baseada na distância real (da tela) entre cada nó e o nó final
function heuristic(graph) {
    var heuristics = [], heuristicsNormed = []
    var sum = 0
    //Posição na tela
    DOMRect = document.getElementById(`${graph.finishNode}`).getBoundingClientRect()
    const finishNodeX = DOMRect.x, finishNodeY = DOMRect.y
    for(let i = 0; i < graph.vertices; i++) {
        DOMRect = document.getElementById(`${i}`).getBoundingClientRect()
        let d1 = Math.abs (DOMRect.x - finishNodeX);
        let d2 = Math.abs (DOMRect.y - finishNodeY);
        let manhattanDistance = d1 + d2;
        // if(manhattanDistance > graph.list[i].<distanceToFinishNode>)
        //     heuristics[i][j] = graph.list[i].<distanceToFinishNode>
        // else
        heuristics[i] = manhattanDistance
        sum = sum + heuristics[i]
    }
    //Normalizar porque as distâncias são >1000
    for(let i = 0; i < graph.vertices; i++) {
        heuristicsNormed[i] = heuristics[i]/sum*25
    }
    return heuristicsNormed;  
}

function findLowestPriority(graph, priorities) {
    var lowestPriority = Infinity;
    var lowestPriorityIndex = -1;
    for (let i = 0; i < priorities.length; i++) {
        if (priorities[i] < lowestPriority && graph.list[i].isVisited === false) {
            lowestPriority = priorities[i];
            lowestPriorityIndex = i;
        }
    }
    return lowestPriorityIndex;
}

function updatePriorityNeighbors(graph, lowestPriorityIndex, priorities, heuristics) {
    for (let p = graph.list[lowestPriorityIndex].getHead(); p !== null; p = p.next) {
        var w = p.id
        var custo = p.distance
        if (graph.list[w].isVisited === false &&
            graph.list[w].distanceToStartNode > graph.list[lowestPriorityIndex].distanceToStartNode + custo) {
                graph.list[w].distanceToStartNode = graph.list[lowestPriorityIndex].distanceToStartNode + custo
                priorities[w] = graph.list[w].distanceToStartNode + heuristics[w];
                graph.list[w].previousNodeId = lowestPriorityIndex //? 
        }
    }
}
